  <template>
  <div>
    <v-row width="110vw">
      <v-card colour="white" width="110vw" class="grid">
        <div>
          <v-img
            :src="this.group.image"
            height="400px"
            width="1000px"
            class="rounded"
          ></v-img>
          <div class="mx-6 my-5">
            <v-row>
              <p class="text-h5 font-weight-bold">{{ this.group.name }}</p>
            </v-row>
            <v-row class="mt-n1 ml-n3">
              <p class="text-caption">
                <v-icon class="mr-1 mb-1" x-small>mdi-lock</v-icon>Private group
                <span class="font-weight-medium">9.1K members</span>
              </p>
            </v-row>
            <v-divider class="mt-4 mx-n3" />
            <v-row class="mt-2 mb-n5 d-flex justify-space-between">
              <div>
                <v-tabs
                  v-model="tab"
                  background-color="white"
                  color="primary"
                  grow
                  centered
                  slider-color="primary"
                >
                  <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
                </v-tabs>
              </div>

              <div class="mt-1">
                <v-btn
                  class="mr-2"
                  color="primary"
                  outlined
                  @click="dialog = true"
                  >Join</v-btn
                >
                <v-btn color="primary" text>Share</v-btn>
              </div>
            </v-row>
          </div>
        </div>
      </v-card>
    </v-row>
    <div max-width="800px">
      <v-row class="mx-2 mt-8 d-flex justify-center">
        <v-col cols="12" md="5">
          <v-tabs-items v-model="tab">
            <v-tab-item class="rentals">
              <group-items />
            </v-tab-item>
            <v-tab-item class="requests">
              <group-requests />
            </v-tab-item>
            <v-tab-item class="members">
              <v-card flat>
                <v-card-text></v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
        <v-col cols="12" md="4">
          <v-card>
            <v-card-title>
              <h2 class="text-subtitle-2 font-weight-bold offblack--text">
                About
              </h2>
            </v-card-title>
            <v-card-text>
              <p>
                {{ this.group.description }}
              </p>
              <v-row>
                <v-col cols="1">
                  <v-icon class="offblack--text">mdi-earth</v-icon>
                </v-col>
                <v-col>
                  <span class="text-subtitle-2 font-weight-bold offblack--text"
                    >Public</span
                  >
                  <p class="text-body-2">
                    Anyone can see who's in the group and what they post.
                  </p>
                </v-col>
              </v-row>
              <v-row class="mt-n2">
                <v-col cols="1">
                  <v-icon class="offblack--text">mdi-map-marker</v-icon>
                </v-col>
                <v-col>
                  <span class="text-subtitle-2 font-weight-bold offblack--text"
                    >Location</span
                  >
                  <p class="text-body-2">
                    {{ this.group.location }}
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
</template>

<script>
import { getFirestore, getDoc, doc } from 'firebase/firestore';

export default {
  name: 'StrappGroup',

  data() {
    return {
      tab: null,
      items: ['rentals', 'requests'],
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      group: {},
      loading: false,
      selection: 1,
    };
  },

  mounted() {
    console.log(this.group);
  },

  components: {
    GroupItems: () => import('@/components/group/groupItems.vue'),
    GroupRequests: () => import('@/components/group/groupRequests.vue'),
  },

  computed: {
    groups() {
      return this.$store.state.groups.groups;
    },
    // groupItems() {
    //   //get  the loadedItems that have this.$route.params.name as part of their group array
    //   return this.$store.state.loadedItems;
    // },
  },

  async created() {
    const db = getFirestore();
    const docRef = doc(db, 'groups', this.$route.params.name);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      console.log('Document data:', docSnap.data());

      this.group = docSnap.data();
    } else {
      // docSnap.data() will be undefined in this case
      console.log('No such document!');
    }

    // this.$store.dispatch('groups/loadGroup', this.$route.params.name);

    // if (this.$store.state.groups.groups) {
    //   this.group = this.$store.state.groups.groups.find(
    //     (group) => group.id === this.$route.params.name
    //   );
    // } else if (!this.$store.state.groups.groups) {
    //   this.$store.dispatch('groups/loadGroups', this.$route.params.name);
    // }
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none !important;
}
</style>
